enum DeclineMeetingSelectionState {
    UseAutomaticReplyMessage = 0,
    CreateNewMessage = 1,
}

export default DeclineMeetingSelectionState;
